// menu hover js
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });


// Select all menu items
const menuItems = document.querySelectorAll(".ctm_megamenu_items ul li");
const collectionData = document.querySelectorAll(".ctm_menu_collection_data");

menuItems.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    const dataTitle = item.getAttribute("data-title");

    collectionData.forEach((dataItem) => {
      const dataValue = dataItem.getAttribute("data-value");
      if (dataTitle === dataValue) {
        dataItem.style.display = "block";
      } else {
        dataItem.style.display = "none";
      }
    });
  });

  // Optional: hide all on mouse leave
  // item.addEventListener("mouseleave", () => {
  //   collectionData.forEach((dataItem) => {
  //     dataItem.style.display = "none";
  //   });
  // });
});


const swiper = new Swiper(".testimonil-wrapper", {
    effect: "fade",       
    loop: true,          
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    fadeEffect: {
      crossFade: true
    }
  });

  /* accordian Js Start */
// document.addEventListener("DOMContentLoaded", () => {
//   const accordions = document.querySelectorAll(".accordion_in_flxs");
//   document.querySelectorAll(".accordian_contains").forEach(c => c.style.display = "none");
//   accordions.forEach(trigger => {
//     trigger.addEventListener("click", function () {
//       const content = this.nextElementSibling;
//       const icon = this.closest(".accordion_inners").querySelector(".accordion_in_icons");
//       const isOpen = content.style.display === "block";
//       document.querySelectorAll(".accordian_contains").forEach(c => c.style.display = "none");
//       document.querySelectorAll(".accordion_in_icons").forEach(i => i.style.transform = "rotate(0deg)");
//       accordions.forEach(a => a.classList.remove("colored_text"));
//       if (!isOpen) {
//         content.style.display = "block";
//         icon.style.transform = "rotate(180deg)";
//         this.classList.add("colored_text");
//       }
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  
  // Run only on homepage
  if (window.location.pathname !== "/" && window.location.pathname !== "/index.html") {
    return; 
  }

  const accordions = document.querySelectorAll(".accordion_in_flxs");
  document.querySelectorAll(".accordian_contains").forEach(c => c.style.display = "none");

  accordions.forEach(trigger => {
    trigger.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const icon = this.closest(".accordion_inners").querySelector(".accordion_in_icons");
      const isOpen = content.style.display === "block";

      document.querySelectorAll(".accordian_contains").forEach(c => c.style.display = "none");
      document.querySelectorAll(".accordion_in_icons").forEach(i => i.style.transform = "rotate(0deg)");
      accordions.forEach(a => a.classList.remove("colored_text"));

      if (!isOpen) {
        content.style.display = "block";
        icon.style.transform = "rotate(180deg)";
        this.classList.add("colored_text");
      }
    });
  });

});


  
// document.addEventListener("DOMContentLoaded", () => {
//   const accordions = document.querySelectorAll(".accordion_in_flxs");

//   document.querySelectorAll(".accordian_contains").forEach(c => {
//     c.style.overflow = "hidden";
//     c.style.maxHeight = "0px";
//     c.style.transition = "max-height 0.3s ease";
//   });

//   function slideDown(elem) {
//     elem.style.display = "block"; // ← FIX: CSS display:none हटेगा
//     elem.style.maxHeight = elem.scrollHeight + "px";
//   }

//   function slideUp(elem) {
//     elem.style.maxHeight = "0px";
//     setTimeout(() => {
//       elem.style.display = "none"; // close par none ho jayega
//     }, 300);
//   }

//   accordions.forEach(trigger => {
//     trigger.addEventListener("click", function () {

//       const content = this.nextElementSibling;
//       const icon = this.closest(".accordion_inners").querySelector(".accordion_in_icons");
//       const isOpen = content.style.display === "block";

//       document.querySelectorAll(".accordian_contains").forEach(c => {
//         if (c !== content) slideUp(c);
//       });

//       document.querySelectorAll(".accordion_in_icons").forEach(i => {
//         if (i !== icon) i.style.transform = "rotate(0deg)";
//       });

//       accordions.forEach(a => {
//         if (a !== this) a.classList.remove("colored_text");
//       });

//       if (!isOpen) {
//         slideDown(content);
//         icon.style.transform = "rotate(180deg)";
//         this.classList.add("colored_text");
//       } else {
//         slideUp(content);
//         icon.style.transform = "rotate(0deg)";
//         this.classList.remove("colored_text");
//       }
//     });
//   });
// });

  /* accordian Js End */

  var swiperImage = new Swiper(".image-slider-active", {
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

  var icon_slider = new Swiper(".icon_data_div", {
  slidesPerView:5,     
  spaceBetween: 20,
  loop: true,               
  allowTouchMove: false,     
  speed: 3000,             
  autoplay: {
    delay: 0,              
    disableOnInteraction: false,
  },
  breakpoints: {
    320: {  
      slidesPerView: 2
    },
    480: {
      slidesPerView: 2
    },
    768: {  
      slidesPerView: 3
    },
    1024: { 
      slidesPerView: 5
    }
  }
});


var image_slider = new Swiper(".ctm_brand_grid_data ", {
  slidesPerView:5,     
  spaceBetween: 25,
  loop: true,               
  allowTouchMove: false,     
  speed: 2500,             
  autoplay: {
    delay: 0,              
    disableOnInteraction: false,
  },
  breakpoints: {
    320: {  
      slidesPerView: 2
    },
    480: {
      slidesPerView: 2
    },
    768: {  
      slidesPerView: 3,
      spaceBetween: 15

    },
    1024: { 
      slidesPerView: 5
    }
  }
});


// document.addEventListener("click", function (event) {
//   if (event.target.matches(".location_collection_btn button")) {
//     let ths_id = event.target.getAttribute("data-tag").trim();
//     document.querySelectorAll(".location_collection_btn button").forEach(btn => {
//       btn.classList.remove("active");
//     });

//     event.target.classList.add("active");

//     document.querySelectorAll("ul#product-grid li").forEach(item => {
//       item.style.display = "none";
//     });

//     document.querySelectorAll("ul#product-grid li").forEach(item => {
//       let thsval = (item.getAttribute("data-tags") || "").trim();
//       if (thsval === ths_id) {
//         item.style.display = "";
//       }
//     });
//   }
// });






document.querySelectorAll(".pro_register_btn").forEach(btn => {
  btn.addEventListener("mouseover", function () {
    let parentWrapper = this.closest(".product__info-wrapper");
    if (parentWrapper) {
      let submitBtn = parentWrapper.querySelector(".product-form__submit");
      if (submitBtn) {
        submitBtn.style.backgroundColor = "#202020";
        submitBtn.style.border = "1px solid #474747";
      }
    }
  });

  btn.addEventListener("mouseout", function () {
    let parentWrapper = this.closest(".product__info-wrapper");
    if (parentWrapper) {
      let submitBtn = parentWrapper.querySelector(".product-form__submit");
      if (submitBtn) {
        submitBtn.style.backgroundColor = "#EE147D";
        submitBtn.style.border = "1px solid #EE147D";
      }
    }
  });
});

document.addEventListener("click", function (e) {
  if (!e.target.closest(".addons_product_list .product_box")) return;
  const clicked = e.target.closest(".addons_product_list .product_box");
  clicked.classList.toggle("actives");
  if (document.querySelectorAll(".addons_product_list .product_box.actives").length) {
    console.log(document.querySelectorAll(".addons_product_list .product_box.actives").length)
    document.querySelectorAll(".product-form__buttons").forEach(el =>
      el.classList.add("add-on-p")
    );
  } else {
    document.querySelectorAll(".product-form__buttons").forEach(el =>
      el.classList.remove("add-on-p")
    );
  }
});





document.addEventListener("click", function(event) {
    const target = event.target.closest(".product-form__buttons.add-on-p");
    if (!target) return;

    if (target.classList.contains("add-on-q")) {
        setTimeout(() => {
            document.querySelectorAll(".add-on-p").forEach(el => el.classList.remove("add-on-q"));
        }, 100);
    } else {
        // Remove any existing custom-prop inputs
        document.querySelectorAll(".custom-prop").forEach(el => el.remove());

        // Generate random number for main product
        const randNum = Math.floor(Math.random() * (999 - 100 + 1) + 100);

        // Append hidden input to all product-form__buttons
        const propInput = document.createElement("input");
        propInput.type = "hidden";
        propInput.className = "custom-prop";
        propInput.name = "properties[_main-product]";
        propInput.value = randNum;

        document.querySelectorAll(".product-form__buttons").forEach(btn => btn.appendChild(propInput));

        // Prepare items data
        const itemsData = { items: [] };
        const activeProducts = document.querySelectorAll(".add-on-product-list-wrap.active .product_box.actives");

        activeProducts.forEach((item, index) => {
            const variantId = parseInt(item.getAttribute("variant_id"));
            const variantQuantityInput = item.querySelector(".addons_quantity");
            const variantQuantity = variantQuantityInput ? variantQuantityInput.value : 1;

            itemsData.items.push({
                quantity: variantQuantity,
                id: variantId,
                properties: { "_bundle-product": randNum }
            });
        });

        target.classList.add("add-on-q");

        // AJAX request using fetch
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(itemsData)
        })
        .then(response => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        })
        .then(() => {
            const btn = target.querySelector("button");
            if (btn) btn.click();
        })
        .catch(() => {
            alert("Something went wrong. Please try again later!");
        });
    }

    // Slider paging info
    const status = document.querySelector(".pagingInfo");
    const slickElement = document.querySelector(".slick-slider");

    if (slickElement && status) {
        slickElement.addEventListener("reInit", updatePaging);
        slickElement.addEventListener("afterChange", updatePaging);
        slickElement.addEventListener("init", updatePaging);
    }

    function updatePaging(event) {
        const slick = event.detail?.slick;
        if (!slick) return;
        const currentSlide = event.detail?.currentSlide || 0;
        status.textContent = `${currentSlide + 1}/${slick.slideCount}`;
    }
});





// document.addEventListener("click", function(e) {
//   const btn = e.target.closest(".location_collection_btn button");
//   if (!btn) return;

//   const ths_id = btn.getAttribute("data-tag").trim();

//   // Remove active class from all buttons
//   document.querySelectorAll(".location_collection_btn button").forEach(b => {
//     b.classList.remove("active");
//   });

//   // Add active class to clicked button
//   btn.classList.add("active");

//   // Show/hide products in the grid
//   document.querySelectorAll("ul#product-grid li").forEach(li => {
//     const thsval = li.getAttribute("data-tags").trim();
//     if (thsval === ths_id) {
//       li.style.display = "";
//     } else {
//       li.style.display = "none";
//     }
//   });
// });

/* Code for Collection Page location button hide duplicate product code start */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".location_collection_btn button");
  if (!btn) return;

  const ths_id = btn.getAttribute("data-tag")?.trim();

  document.querySelectorAll(".location_collection_btn button").forEach(b => b.classList.remove("active"));
  btn.classList.add("active");

  document.querySelectorAll(".collection ul#product-grid li").forEach(li => {
    const tag = li.getAttribute("data-tags")?.trim();
    li.style.display = (tag === ths_id) ? "" : "none";
  });

  markDuplicateItems();
});

function markDuplicateItems() {
  const grid = document.querySelector(".collection ul#product-grid");
  if (!grid) return;

  const visibleItems = [...grid.querySelectorAll("li")].filter(li => li.style.display !== "none");

  const seen = new Set();

  visibleItems.forEach(li => {
    const ind = li.getAttribute("data-ind")?.trim();
    if (!ind) return;

    if (seen.has(ind)) {
      li.classList.add("hide-product-grid");
    } else {
      seen.add(ind);
      li.classList.remove("hide-product-grid");
    }
  });
}

const grid = document.querySelector(".collection ul#product-grid");
if (grid) {
  const obs = new MutationObserver(() => markDuplicateItems());
  obs.observe(grid, { childList: true, subtree: false });
}

/* Code for Collection Page location button hide duplicate product code End */



document.addEventListener("input", function(e) {
  const input = e.target.closest("input.location_minimum_quantity");
  if (!input) return;

  const minLimit = 6;
  const currentNumber = parseInt(input.value, 10);

  const submitButtons = document.querySelectorAll(".product-form__submit");

  if (isNaN(currentNumber) || currentNumber < minLimit) {
    input.classList.add("no_enter_value");
    submitButtons.forEach(btn => btn.classList.add("no_enter_value"));
  } else {
    input.classList.remove("no_enter_value");
    submitButtons.forEach(btn => btn.classList.remove("no_enter_value"));
  }
});

/* Js for product media change by arrow */

// (function () {

//   function isDesktop() {
//     return window.innerWidth >= 749;
//   }

//   function initDesktopGallerySlider() {
//     if (!isDesktop()) return;

//     document.querySelectorAll('media-gallery').forEach(gallery => {
//       const viewer = gallery.querySelector('[id^="GalleryViewer"] ul.slider');
//       const thumbSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
//       const sliderComponent = gallery.querySelector('slider-component.slider-mobile-gutter');

//       if (!viewer || !sliderComponent) return;

//       const slides = Array.from(viewer.querySelectorAll('li[data-media-id]'));
//       if (!slides.length) return;

//       const btnPrev = sliderComponent.querySelector('.slider-button--prev');
//       const btnNext = sliderComponent.querySelector('.slider-button--next');
//       const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
//       const counterTotal = sliderComponent.querySelector('.slider-counter--total');

//       if (counterTotal) counterTotal.textContent = slides.length;

//       function getActiveIndex() {
//         const i = slides.findIndex(s => s.classList.contains('is-active'));
//         return i === -1 ? 0 : i;
//       }

//       function activateThumbnails(mediaId) {
//         if (!thumbSlider) return;

//         const allThumbs = thumbSlider.querySelectorAll('[data-target]');
//         allThumbs.forEach(t => t.querySelector('button')?.removeAttribute('aria-current'));

//         const activeThumb = thumbSlider.querySelector(`[data-target="${mediaId}"]`);
//         if (activeThumb) {
//           activeThumb.querySelector('button')?.setAttribute('aria-current', 'true');

//           if (thumbSlider.slider && !thumbSlider.isSlideVisible(activeThumb, 10)) {
//             thumbSlider.slider.scrollTo({ left: activeThumb.offsetLeft });
//           }
//         }
//       }

//       function activateSlide(i) {
//         if (i < 0) i = 0;
//         if (i >= slides.length) i = slides.length - 1;

//         slides.forEach(s => s.classList.remove('is-active'));
//         const active = slides[i];
//         active.classList.add('is-active');

//         viewer.style.scrollBehavior = 'auto';
//         viewer.scrollTo({ left: active.offsetLeft });
//         viewer.style.scrollBehavior = '';

//         activateThumbnails(active.dataset.mediaId);

//         if (counterCurrent) counterCurrent.textContent = i + 1;
//         if (btnPrev) btnPrev.disabled = i === 0;
//         if (btnNext) btnNext.disabled = i === slides.length - 1;
//       }

//       function go(offset) {
//         activateSlide(getActiveIndex() + offset);
//       }

//       if (btnPrev) btnPrev.onclick = e => { e.preventDefault(); go(-1); };
//       if (btnNext) btnNext.onclick = e => { e.preventDefault(); go(1); };

//       if (thumbSlider) {
//         thumbSlider.querySelectorAll('[data-target]').forEach(t => {
//           t.querySelector('button')?.addEventListener('click', () => {
//             const i = slides.findIndex(s => s.dataset.mediaId === t.dataset.target);
//             activateSlide(i);
//           });
//         });
//       }

//       activateSlide(getActiveIndex());
//     });
//   }

//   // Run once after page load
//   document.addEventListener("DOMContentLoaded", () => {
//     setTimeout(initDesktopGallerySlider, 2000);
//   });

//   // ⭐ FIXED MutationObserver — only runs when media-gallery changes
//   const observer = new MutationObserver((mutations) => {
//     let shouldRun = false;

//     mutations.forEach(mutation => {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1 && node.matches?.("media-gallery, media-gallery *")) {
//           shouldRun = true;
//         }
//       });
//       mutation.removedNodes.forEach(node => {
//         if (node.nodeType === 1 && node.matches?.("media-gallery, media-gallery *")) {
//           shouldRun = true;
//         }
//       });
//     });

//     if (shouldRun) {
//       setTimeout(initDesktopGallerySlider, 100);
//     }
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// })();

/* Js for product media change by arrow  DND*/
(function () {

  function isDesktop() {
    return window.innerWidth >= 749;
  }

  function initDesktopGallerySlider() {
    if (!isDesktop()) return;

    document.querySelectorAll('media-gallery').forEach(gallery => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"] ul.slider');
      const thumbSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
      const sliderComponent = gallery.querySelector('slider-component.slider-mobile-gutter');

      if (!viewer || !sliderComponent) return;

      const slides = Array.from(viewer.querySelectorAll('li[data-media-id]'));
      if (!slides.length) return;

      const btnPrev = sliderComponent.querySelector('.slider-button--prev');
      const btnNext = sliderComponent.querySelector('.slider-button--next');
      const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
      const counterTotal = sliderComponent.querySelector('.slider-counter--total');

      if (counterTotal) counterTotal.textContent = slides.length;

      function getActiveIndex() {
        const i = slides.findIndex(s => s.classList.contains('is-active'));
        return i === -1 ? 0 : i;
      }

      function activateThumbnails(mediaId) {
        if (!thumbSlider) return;

        const allThumbs = thumbSlider.querySelectorAll('[data-target]');
        allThumbs.forEach(t => t.querySelector('button')?.removeAttribute('aria-current'));

        const activeThumb = thumbSlider.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumb) {
          activeThumb.querySelector('button')?.setAttribute('aria-current', 'true');

          if (thumbSlider.slider && !thumbSlider.isSlideVisible(activeThumb, 10)) {
            thumbSlider.slider.scrollTo({ left: activeThumb.offsetLeft });
          }
        }
      }

      function activateSlide(i) {
        if (i < 0) i = 0;
        if (i >= slides.length) i = slides.length - 1;

        slides.forEach(s => s.classList.remove('is-active'));
        const active = slides[i];
        active.classList.add('is-active');

        viewer.style.scrollBehavior = 'auto';
        viewer.scrollTo({ left: active.offsetLeft });
        viewer.style.scrollBehavior = '';

        activateThumbnails(active.dataset.mediaId);

        if (counterCurrent) counterCurrent.textContent = i + 1;
        if (btnPrev) btnPrev.disabled = i === 0;
        if (btnNext) btnNext.disabled = i === slides.length - 1;
      }

      function go(offset) {
        activateSlide(getActiveIndex() + offset);
      }

      if (btnPrev) btnPrev.onclick = e => { e.preventDefault(); go(-1); };
      if (btnNext) btnNext.onclick = e => { e.preventDefault(); go(1); };

      if (thumbSlider) {
        thumbSlider.querySelectorAll('[data-target]').forEach(t => {
          t.querySelector('button')?.addEventListener('click', () => {
            const i = slides.findIndex(s => s.dataset.mediaId === t.dataset.target);
            activateSlide(i);
          });
        });
      }

      activateSlide(getActiveIndex());
    });
  }

  function debounce(fn, delay) {
    let timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initDesktopGallerySlider, 2000);
  });

  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches?.("media-gallery, media-gallery *")) {
          shouldRun = true;
        }
      });
      mutation.removedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches?.("media-gallery, media-gallery *")) {
          shouldRun = true;
        }
      });
    });

    if (shouldRun) {
      setTimeout(initDesktopGallerySlider, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', debounce(() => {
    if (window.innerWidth >= 749) {
      setTimeout(initDesktopGallerySlider, 200);
    }
  }, 150));

})();


/* Js for collection Tab and sync with Infinte Scroll in Collection grid DND */
function runCollectionFilter() {
	let activeBtn = document.querySelector('.location_collection_btn button.active');
	if (!activeBtn) return;
	let activeTag = activeBtn.getAttribute('data-tag').trim();
	document.querySelectorAll('ul#product-grid li').forEach((item) => {
		let itemTag = (item.getAttribute('data-tags') || '').trim();
		item.style.display = itemTag === activeTag ? '' : 'none';
	});
}

document.addEventListener('DOMContentLoaded', function() {
	runCollectionFilter();
});

document.addEventListener('click', function(event) {
	if (event.target.matches('.location_collection_btn button')) {
		document.querySelectorAll('.location_collection_btn button').forEach((btn) => {
			btn.classList.remove('active');
		});
		event.target.classList.add('active');
		runCollectionFilter();
	}
});

var ajaxinateInstance;

function startAjaxinate() {
	if (ajaxinateInstance && ajaxinateInstance.container) {
		window.removeEventListener('scroll', ajaxinateInstance.checkIfMorePosts);
	}

	ajaxinateInstance = new Ajaxinate({
		container: '.AjaxinateLoop',
		pagination: '.AjaxinatePagination',
		append: true,
		scroll: true,
		callback: function() {
			runCollectionFilter();
		},
	});

	window.addEventListener('scroll', function() {
		if (!ajaxinateInstance.nextPageLink) return;
		const scrollPos = window.scrollY + window.innerHeight;
		const triggerPoint = document.documentElement.scrollHeight - 300;
		if (scrollPos >= triggerPoint) {
			ajaxinateInstance.checkIfMorePosts();
		}
	});
}

document.addEventListener('DOMContentLoaded', startAjaxinate);

document.addEventListener('change', function(e) {
	if (e.target.matches('select[name="sort_by"]')) {
		setTimeout(function() {
			startAjaxinate();
		}, 1000);
	}
});


const title = document.querySelector('.main-page-title');

if (title && title.textContent.includes("Contact Us")) {

    let text = title.textContent.trim();

    let newText = text.replace("Contact", '<span class="contact-content">Contact</span>');

    title.innerHTML = newText;
}
